import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { ContentsCarouselDreams } from 'containers/CarouselsDisplay/components/ContentsCarouselContainer/components/ContentsCarouselDreams';
import './CarouselSubmenu/style.scss';
import { useGetItemType } from 'containers/CarouselsDisplay/components/ContentsCarouselContainer/hooks/useGetItemType';
import { getAssets } from 'reducers/responseAsset';
import SensitiveModal from 'components/SensitiveModal';

const Carousel = ({ dataSubmenu }) => {
  const asset = useSelector(getAssets);

  const { getComponent } = useGetItemType();

  return (
    <div className="submenu__carousel">
      <ContentsCarouselDreams
        contentsList={dataSubmenu}
        getComponent={getComponent}
        carouselType="submenu"
        carouselSubType="submenu"
      />
      <SensitiveModal />
    </div>
  );
};

Carousel.propTypes = {
  dataSubmenu: PropTypes.array,
};

export default Carousel;
